export const marqueeItems = [
  "Metal",
  "Hardware",
  "Furniture",
  "Lighting",
  "Tableware",
] as const;